import { Route } from 'react-router-dom';

import Landing from './landing';

import EmployeeExp from './solutions/employeeExp';
import CustomerExp from './solutions/customerExp';
import SecondaryRes from './solutions/secondaryRes';

import DOE from './usecase/DOE';
import PEA from './usecase/PEA';
import DEI from './usecase/DEI';
import BSM from './usecase/BSM';
import DCS from './usecase/DCS';
import PCA from './usecase/PCA';
import OCC from './usecase/OCC';
import DIS from './usecase/DIS';
import ATU from './usecase/ATU';
import MRT from './usecase/MRT';

import EJI from './sample/EJI';
import CX from './sample/CX';
import MII from './sample/MII';

import Perspective from './perspective';
import DecliningNPS from './perspectives/decliningNPS';
import AnalyzeFeedback from './perspectives/analyzeFeedback';
import FeedbackToAdvantage from './perspectives/feedbackToAdvantage';
import EmployeeDisengagement from './perspectives/employeeDisengagement';
import LearningPrograms from './perspectives/learningPrograms';
import DecliningEngagement from './perspectives/decliningEngagement';
import SegmentingCustomers from './perspectives/segmentingCustomers';
import CxTrends from './perspectives/cxTrends';
import SupportTeam from './perspectives/supportTeam';

import Pricing from './pricing';

import Contact from './contact';

import Tool from '../tool/main';
import Test from '../tool/test';

const pageInfo =
{
    '/': { root: <Landing/> },

    '/solutions':
    {
        '/employee-experience': <EmployeeExp/>,
        '/customer-experience': <CustomerExp/>,
        '/secondary-research': <SecondaryRes/>
    },

    '/usecase':
    {
        '/DOE': <DOE/>,
        '/PEA': <PEA/>,
        '/DEI': <DEI/>,
        '/BSM': <BSM/>,
        '/DCS': <DCS/>,
        '/PCA': <PCA/>,
        '/OCC': <OCC/>,
        '/DIS': <DIS/>,
        '/ATU': <ATU/>,
        '/MRT': <MRT/>
    },

    '/sample':
    {
        '/EJI': <EJI/>,
        '/CX': <CX/>,
        '/MII': <MII/>
    },

    '/perspective':
    {
        root: <Perspective/>,
        '/declining-nps': <DecliningNPS/>,
        '/analyze-feedback': <AnalyzeFeedback/>,
        '/feedback-to-advantage': <FeedbackToAdvantage/>,
        '/employee-disengagement': <EmployeeDisengagement/>,
        '/learning-programs': <LearningPrograms/>,
        '/declining-engagement': <DecliningEngagement/>,
        '/segmenting-customers': <SegmentingCustomers/>,
        '/cx-trends': <CxTrends/>,
        '/support-team': <SupportTeam/>
    },

    '/pricing': { root: <Pricing/> },

    '/contact': { root: <Contact/> },

    '/tool': { root: <Tool/> },

    '/test': { root: <Test/> }
};

let key = 0;
const pagesJSX = [];

for (const x in pageInfo)
{
    for (const y in pageInfo[x])
    {
        if (y === 'root') pagesJSX.push(<Route key={key++} path={x} element={pageInfo[x][y]}/>);

        pagesJSX.push(<Route key={key++} path={x + y} element={pageInfo[x][y]}/>);
    }
}

export { pagesJSX, pageInfo };